module.exports = __webpack_public_path__ + "static/media/pm_kse_small.41f84f33.jpg";